import { IonContent, IonModal } from "@ionic/react";
import style from "../../../style/Friends.module.css";
// import matt from "../../../image/friends/matt.png";

import { showToastMessage } from "components/GlobalLoading";
import { SVGProps } from "components/Notification";
import { FC } from "react";
import { localSet } from "utils/localStorage";
import avatarGroup from '../../../image/friends/avatarGroup.jpg';
import { useStore } from "../../../store";
interface UserInfoModalProps {
    // user: User
    userId: string
    changeSearchState: (isOpen: boolean) => void
}

const UserInfoModal: React.FC<UserInfoModalProps> = ({ userId, changeSearchState }) => {
    // const [member,setMember] = useState<any>()
    const { changeModalState, setGlobalState, currentRoomInfo, isUserInfoModalOpen } = useStore();

    const handleGiftVoucher = () => {
        if (currentRoomInfo?.isGroup) {
            // showToastMessage('This feature is not yet available')
            // return
            changeModalState('isUserInfoModalOpen', false)
            setGlobalState('inFriends', true)
            changeModalState('isGroupVoucherChooseModalOpen', true)
        } else {
            localSet('giftTo', {
                user: userId,
                from: 'friends',
                method: 'wallet'
            })
            // changeModalState('isUserInfoModalOpen', false)
            setGlobalState('inFriends', true)
            changeModalState('isGiftOptionsModalOpen', true)
        }
    }
    const handleIsSearch = () => {
        changeSearchState(true)
    }
/*     const closeChooseVoucherModal = () => {

    } */
    const onDidDismiss = () => {
        changeModalState('isUserInfoModalOpen', false)
    }
    return (
        <IonModal
            isOpen={isUserInfoModalOpen}
            mode="ios"
            handle={false}
            className={style.avatarModal}
            initialBreakpoint={0.4}
            breakpoints={[0.4, 0.45, 0.5]}
            onDidDismiss={onDidDismiss}
        >
            <IonContent>
                <div className={style.modalmain}>
                    {
                        !currentRoomInfo?.isGroup ?
                            (<>
                                <img src={currentRoomInfo?.avatar} alt="" />
                                <div className={style.des}>
                                    <span>{currentRoomInfo?.name}</span>
                                    {/* <p>Won $12944.20</p> */}
                                </div>
                            </>) : (
                                <>
                                    {currentRoomInfo?.avatar ? <img src={currentRoomInfo?.avatar} alt="" style={{ borderRadius: "50%" }} /> : <img src={avatarGroup} alt="" style={{ borderRadius: "50%" }} />}
                                    <div className={style.des}>
                                        <span>{currentRoomInfo?.name}</span>
                                        {/* <p>Won $12944.20</p> */}
                                    </div>
                                </>
                            )
                    }
                    <ul>
                        <li onClick={handleGiftVoucher}>
                            <GiftSVG />
                            Gift a Voucher
                        </li>
                        <li onClick={handleIsSearch}>
                            <SearchSVG />
                            Search
                        </li>
                        <li style={{ color: '#FF6881' }}
                            onClick={() => {
                                showToastMessage('This feature is not yet available.')
                            }}
                        >
                            <BlockSVG />
                            Block
                        </li>
                    </ul>
                </div>
            </IonContent>
        </IonModal>
    )
}
export default UserInfoModal;




const SearchSVG: FC<SVGProps> = (props) => (
    <svg width="21" height="20" viewBox="0 0 21 20" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M13.6291 11.8792H12.9707L12.7374 11.6542C13.5541 10.7042 14.0457 9.47086 14.0457 8.12919C14.0457 5.13752 11.6207 2.71252 8.62907 2.71252C5.6374 2.71252 3.2124 5.13752 3.2124 8.12919C3.2124 11.1209 5.6374 13.5459 8.62907 13.5459C9.97074 13.5459 11.2041 13.0542 12.1541 12.2375L12.3791 12.4709V13.1292L16.5457 17.2875L17.7874 16.0459L13.6291 11.8792ZM8.62907 11.8792C6.55407 11.8792 4.87907 10.2042 4.87907 8.12919C4.87907 6.05419 6.55407 4.37919 8.62907 4.37919C10.7041 4.37919 12.3791 6.05419 12.3791 8.12919C12.3791 10.2042 10.7041 11.8792 8.62907 11.8792Z" fill="#9C94FF" />
    </svg>
)

const BlockSVG: FC<SVGProps> = (props) => (
    <svg width="21" height="20" viewBox="0 0 21 20" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M10.5001 1.66663C5.90008 1.66663 2.16675 5.39996 2.16675 9.99996C2.16675 14.6 5.90008 18.3333 10.5001 18.3333C15.1001 18.3333 18.8334 14.6 18.8334 9.99996C18.8334 5.39996 15.1001 1.66663 10.5001 1.66663ZM10.5001 16.6666C6.81675 16.6666 3.83341 13.6833 3.83341 9.99996C3.83341 8.45829 4.35841 7.04163 5.24175 5.91663L14.5834 15.2583C13.4584 16.1416 12.0417 16.6666 10.5001 16.6666ZM15.7584 14.0833L6.41675 4.74163C7.54175 3.85829 8.95842 3.33329 10.5001 3.33329C14.1834 3.33329 17.1667 6.31663 17.1667 9.99996C17.1667 11.5416 16.6417 12.9583 15.7584 14.0833Z" fill="#FF6881" />
    </svg>
)
const GiftSVG: FC<SVGProps> = (props) => (

    <svg width="21" height="20" viewBox="0 0 21 20" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M18.8335 10V16.6667C18.8335 17.1087 18.6579 17.5326 18.3453 17.8452C18.0328 18.1578 17.6089 18.3334 17.1668 18.3334H3.8335C3.39147 18.3334 2.96755 18.1578 2.65498 17.8452C2.34242 17.5326 2.16683 17.1087 2.16683 16.6667V10C1.94582 10 1.73385 9.91222 1.57757 9.75594C1.42129 9.59966 1.3335 9.3877 1.3335 9.16669V6.66669C1.3335 6.22466 1.50909 5.80074 1.82165 5.48818C2.13421 5.17562 2.55814 5.00002 3.00016 5.00002H5.64183C5.55016 4.74169 5.50016 4.45835 5.50016 4.16669C5.50016 3.50365 5.76355 2.86776 6.2324 2.39892C6.70124 1.93008 7.33712 1.66669 8.00016 1.66669C8.8335 1.66669 9.56683 2.08335 10.0252 2.70002V2.69169L10.5002 3.33335L10.9752 2.69169V2.70002C11.4335 2.08335 12.1668 1.66669 13.0002 1.66669C13.6632 1.66669 14.2991 1.93008 14.7679 2.39892C15.2368 2.86776 15.5002 3.50365 15.5002 4.16669C15.5002 4.45835 15.4502 4.74169 15.3585 5.00002H18.0002C18.4422 5.00002 18.8661 5.17562 19.1787 5.48818C19.4912 5.80074 19.6668 6.22466 19.6668 6.66669V9.16669C19.6668 9.3877 19.579 9.59966 19.4228 9.75594C19.2665 9.91222 19.0545 10 18.8335 10ZM3.8335 16.6667H9.66683V10H3.8335V16.6667ZM17.1668 16.6667V10H11.3335V16.6667H17.1668ZM8.00016 3.33335C7.77915 3.33335 7.56719 3.42115 7.41091 3.57743C7.25463 3.73371 7.16683 3.94567 7.16683 4.16669C7.16683 4.3877 7.25463 4.59966 7.41091 4.75594C7.56719 4.91222 7.77915 5.00002 8.00016 5.00002C8.22118 5.00002 8.43314 4.91222 8.58942 4.75594C8.7457 4.59966 8.8335 4.3877 8.8335 4.16669C8.8335 3.94567 8.7457 3.73371 8.58942 3.57743C8.43314 3.42115 8.22118 3.33335 8.00016 3.33335ZM13.0002 3.33335C12.7791 3.33335 12.5672 3.42115 12.4109 3.57743C12.2546 3.73371 12.1668 3.94567 12.1668 4.16669C12.1668 4.3877 12.2546 4.59966 12.4109 4.75594C12.5672 4.91222 12.7791 5.00002 13.0002 5.00002C13.2212 5.00002 13.4331 4.91222 13.5894 4.75594C13.7457 4.59966 13.8335 4.3877 13.8335 4.16669C13.8335 3.94567 13.7457 3.73371 13.5894 3.57743C13.4331 3.42115 13.2212 3.33335 13.0002 3.33335ZM3.00016 6.66669V8.33335H9.66683V6.66669H3.00016ZM11.3335 6.66669V8.33335H18.0002V6.66669H11.3335Z" fill="#9C94FF" />
    </svg>
)